// Link types are stored lowercase; display them title-cased.
export const titleCaseType = (type: string): string => {
    if (!type) return '';
    return type
        .split(/[\s_-]+/)
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

// Normalize a freeform type entry to the stored form (lowercase, trimmed).
export const normalizeType = (type: string): string => type.trim().toLowerCase();

// Curated links resolve product details through the same stock filter the tables use.
export const passesStockFilter = (product: { vendors?: { inStock?: boolean; cost?: number; onHand?: number }[] }): boolean =>
    product.vendors?.some(v => v.inStock && v?.cost && v.cost > 0 && v.onHand && v?.onHand > 0) ?? false;
